import React from 'react';
import PropTypes from 'prop-types';
import { StyledBotonComprobante } from './styles';
import ImgIcon from '../ImgIcon';
import { isMobile } from '../../../../utils/platform';

const BotonComprobante = ({ icon, handleClick, text }) => {
  return (
    <StyledBotonComprobante>
      <button
        type="button"
        onClick={() => handleClick()}
        disabled={false}
      >
        <ImgIcon icon={icon} width={20} height={20} alt="survey icon" />
        {!isMobile() && <span className="pl-2">{text}</span>}
      </button>
    </StyledBotonComprobante>
  );
};

BotonComprobante.propTypes = {
  icon: PropTypes.shape({}).isRequired,
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default BotonComprobante;
